export const PERSONS_REPRESENTATIVES_TABLE_CHANGE = 'PERSONS_REPRESENTATIVES_TABLE_CHANGE'
export const PERSONS_REPRESENTATIVES_TABLE_DATA_RECEIVED = 'PERSONS_REPRESENTATIVES_TABLE_DATA_RECEIVED'
export const PERSONS_REPRESENTATIVES_TABLE_LOADING_TRUE = 'PERSONS_REPRESENTATIVES_TABLE_LOADING_TRUE'
export const PERSONS_REPRESENTATIVES_TABLE_LOADING_FALSE = 'PERSONS_REPRESENTATIVES_TABLE_LOADING_FALSE'

export const PERSONS_REPRESENTATIVES_TABLE_CHANGE_REQUEST = (id) => `PERSONS_REPRESENTATIVES_${id}_TABLE_CHANGE_REQUEST`
